export default __webpack_public_path__ + "static/media/ic_export_up_arrow_primary.a38eea11.svg";